var browserHistory;
jQuery(document).ready(function() {
  
  // Getting value of token from request parameter.
  var phoneorder_token = getParameterByName('token');
  if(phoneorder_token && phoneorder_token != null){
    
    jQuery.ajax({
        dataType: "json",
        url: "https://shopifyapi.dbuytest.info/api/verify-token-permission",
        cache: false,
        method: 'GET',
        beforeSend: function(request) {
          request.setRequestHeader("Authorization", "Bearer"+phoneorder_token);
        },
        success: function(response) {
            // Checking if phone order session exists or not.
            var phoneorder_session = sessionStorage.getItem("phoneorder-token");
            if(phoneorder_session != ""){
              sessionStorage.removeItem("phoneorder-token");
            }
            sessionStorage.setItem("phoneorder-token", phoneorder_token);
          
            // Checking if checkout is allowed or not.
            if(response.is_checkout_allowed == "false" || response.is_checkout_allowed == false){
              var is_checkout_allowed = sessionStorage.getItem("is-checkout-allowed");
              if(is_checkout_allowed != ""){
                sessionStorage.removeItem("is-checkout-allowed");
              }
              sessionStorage.setItem("is-checkout-allowed", "no");
            }
            window.location.href = "http://" + window.location.hostname;
        }//success close  
      });//ajax close
  }

  jQuery('body').prepend( '<div id="dividebuy-shipping-loader" class="dividebuy-loader-set" style="margin:0;display: none"><div id="dividebuy-loader"></div></div>');
  jQuery('body').prepend('<div class="dividebuy-softcredit"><div id="dividebuy_modal_softcredit_search" class="modal fade dividebuy-modal custom-modal soft-search dividebuy-soft-search">    <div class="modal-dialog modal-lg">       <div class="modal-header clearfix">           <a href="javascript:void(0);" id="softcredit-scroll"  data-dismiss="modal" class="close shopify_close">X</a>          </div>                <div class="modal-content" style="overflow:hidden">                <iframe tabindex="3" frameborder="0" id="frame-dividebuy-softcredit-check" src="" width="100%" class="frame"></iframe>                <div class="modal-body clearfix">                    <div class="popup">                      <div id="shipping-loader-softsearch" class="dividebuy-loader-set" style="margin:0;display: none">                        <div id="dividebuy-loader"></div>                      </div>                    </div> </div> </div></div></div></div>');

  //check order is cancel than get back the dividebuy products to cart
  var url      = window.location.href; 
  if(window.location.href.indexOf("?") > -1)
  {
   // spliting the data if query string is there
    var pieces = url.split("?");
    var cancelFlag = pieces[1].split("=");
    if(cancelFlag[0] == 'cancel')
    {
      jQuery("html").addClass('loader-on');
      jQuery("#dividebuy-shipping-loader").show();
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://shopifyapi.dbuytest.info/api/cancel-order-products?splashKey="+cancelFlag[1],
        "method": "GET",
        "headers": {
          "content-type": "application/json",

        },
        "processData": false,
      }
      jQuery.ajax(settings).done(function (response) {
        if(response.status == 'ok')
        {
          var _array = response.products;
          var addAjaxes     = [];
          jQuery.each(_array, function( key, value ) {
            var addAjax = jQuery.ajax({
              method  : 'post',
              url   : '/cart/add.js',
              data  : {
                quantity: _array[key].qty,
                id: _array[key].id
              }

            });
            addAjaxes.push(addAjax);
          });//add ajax close
          jQuery.when(addAjaxes).then(function(){
            setTimeout(function() { location.href = '/cart';  }, 5000);  
          });
          localStorage.clear();
        }else{
          alert("There is something went wrong with cart.");
          return false;
        }
      }).fail(function(){
        alert("There is something went wrong with cart.");
        return false;
      });
    }
  }
});

// Function for getting parameter name from request URL
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* Only functions*/

//Unserialize data from jquery
function unserialize (data) {
  var $global = (typeof window !== 'undefined' ? window : global)
  var utf8Overhead = function (str) {
    var s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
      var code = str.charCodeAt(i)
      if (code > 0x7f && code <= 0x7ff) {
        s++
      } else if (code > 0x7ff && code <= 0xffff) {
        s += 2
      }
      // trail surrogate
      if (code >= 0xDC00 && code <= 0xDFFF) {
        i--
      }
    }
    return s - 1
  }
  var error = function (type,
                         msg, filename, line) {
    throw new $global[type](msg, filename, line)
  }
  var readUntil = function (data, offset, stopchr) {
    var i = 2
    var buf = []
    var chr = data.slice(offset, offset + 1)

    while (chr !== stopchr) {
      if ((i + offset) > data.length) {
        error('Error', 'Invalid')
      }
      buf.push(chr)
      chr = data.slice(offset + (i - 1), offset + i)
      i += 1
    }
    return [buf.length, buf.join('')]
  }
  var readChrs = function (data, offset, length) {
    var i, chr, buf

    buf = []
    for (i = 0; i < length; i++) {
      chr = data.slice(offset + (i - 1), offset + i)
      buf.push(chr)
      length -= utf8Overhead(chr)
    }
    return [buf.length, buf.join('')]
  }
  function _unserialize (data, offset) {
    var dtype
    var dataoffset
    var keyandchrs
    var keys
    var contig
    var length
    var array
    var readdata
    var readData
    var ccount
    var stringlength
    var i
    var key
    var kprops
    var kchrs
    var vprops
    var vchrs
    var value
    var chrs = 0
    var typeconvert = function (x) {
      return x
    }

    if (!offset) {
      offset = 0
    }
    dtype = (data.slice(offset, offset + 1)).toLowerCase()

    dataoffset = offset + 2

    switch (dtype) {
      case 'i':
        typeconvert = function (x) {
          return parseInt(x, 10)
        }
        readData = readUntil(data, dataoffset, ';')
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 1
        break
        case 'b':
        typeconvert = function (x) {
          return parseInt(x, 10) !== 0
        }
        readData = readUntil(data, dataoffset, ';')
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 1
        break
        case 'd':
        typeconvert = function (x) {
          return parseFloat(x)
        }
        readData = readUntil(data, dataoffset, ';')
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 1
        break
        case 'n':
        readdata = null
        break
        case 's':
        ccount = readUntil(data, dataoffset, ':')
        chrs = ccount[0]
        stringlength = ccount[1]
        dataoffset += chrs + 2

        readData = readChrs(data, dataoffset + 1, parseInt(stringlength, 10))
        chrs = readData[0]
        readdata = readData[1]
        dataoffset += chrs + 2
        if (chrs !== parseInt(stringlength, 10) && chrs !== readdata.length) {
          error('SyntaxError', 'String length mismatch')
        }
        break
        case 'a':
        readdata = {}

        keyandchrs = readUntil(data, dataoffset, ':')
        chrs = keyandchrs[0]
        keys = keyandchrs[1]
        dataoffset += chrs + 2

        length = parseInt(keys, 10)
        contig = true

        for (i = 0; i < length; i++) {
          kprops = _unserialize(data, dataoffset)
          kchrs = kprops[1]
          key = kprops[2]
          dataoffset += kchrs

          vprops = _unserialize(data, dataoffset)
          vchrs = vprops[1]
          value = vprops[2]
          dataoffset += vchrs

          if (key !== i) {
            contig = false
          }

          readdata[key] = value
        }

        if (contig) {
          array = new Array(length)
          for (i = 0; i < length; i++) {
            array[i] = readdata[i]
          }
          readdata = array
        }

        dataoffset += 1
        break
        default:
        error('SyntaxError', 'Unknown / Unhandled data type(s): ' + dtype)
        break
    }
    return [dtype, dataoffset - offset, typeconvert(readdata)]
  }

  return _unserialize((data + ''), 0)[2]
}
/* Checking the IP Shopify is not supporting this feature to get ip directly*/

function CheckIP(IpData)
{
   if(IpData == '0' || IpData == ''){
   
      jQuery('.dividebuy_logo_section').show();  
     return true;
    }
    jQuery.getJSON("http://jsonip.com/?callback=?", function (data) {

    var IpArray = IpData.split(',');
    var flag = "";
    jQuery.each( IpArray , function( key, value ) {
      if(value == data.ip ){
        flag = 1;
      }

      });   

    if(flag == 1){
      jQuery('.dividebuy_logo_section').show();
      jQuery('.softcredit').show();
    }   
  });
}
/* forinstallment tooltip*/
function GetInstallmentData(serializedata,Dprice){
  var html = '';
  var disable ='';
  var Divideprice = Dprice;
  for(value in serializedata ){
    var compare_price = serializedata[value].value;
    if( Divideprice < compare_price)
    {
      disable = 'hover-disable';
    }
    var month = serializedata[value].key;
    var divideratio = (Divideprice/month).toFixed(2);

    var totalprice = (Divideprice).toFixed(2);
  totalprice = totalprice.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    divideratio = divideratio.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    html += '<div class="hover-instalment '+disable+'">';
    html += '<div class="highlights-instalments blue-text">'+month +' </div>';
    html += '<div class="monthly-instalments">monthly instalments of </div>';
    html += '<div class="highlights-amt blue-text"> £'+divideratio+' = </div>';
    html += '<div class="highlights-amt green-text"> £'+totalprice+'</div>';
    html +=  '<div class="clearfix"></div>'
    html +=  '</div>';
  }
  return(html);
}
// Replace number with comma
function parseNumberCustom(number_string) {

  var new_number = number_string.replace(/,/g , '');
  return new_number;
}
//Checking for minimum order
function MinimumOrderValue(serializedata,price)
{
  var i = false;
  for(value in serializedata ){
    if( price >= serializedata[value].value)
    {
      i = true;
      break;        
    }
  } 
  return i;
}
//on cart page minimuorder condtion satisfied
function MimimuOrderToolTip(serializedata,Dprice_total)
{
  showDevideByTP = true;
  var DBprice = Dprice_total;
  jQuery(".tooltip-dividebuy-1").removeClass("dnone");
  jQuery(".instalment-details").html("");
  var startTime = new Date();
  var now = new Date();
  var difference = (now.getTime() - startTime.getTime()) / 1000;
  var seconds = 3000 - (difference * 1000);
  setTimeout(function() {
    //GetInstallment data
    
    var response = GetInstallmentData(serializedata,DBprice);    
    jQuery('#instalment-loader').removeClass('small-dividebuy-loader');
    jQuery(".instalment-details").html(response);
  }, seconds);
}
//Find only minmumamoutn
function MinimumAmount(serializedata)
{
  var min=null, max=null;
  for(value in serializedata ){
    var id = parseInt(serializedata[value].value);
    if ((min===null) || (id < min)) { min = id; }
    if ((max===null) || (id > max)) { max = id; }
  } 
  return min;
}


//on cart page minimuorder condtion dissatisfied
function DisMimimuOrderToolTip(serializedata)
{
  var minOrderamount = getOrderAmount(serializedata);
  var jq1113 = jQuery.noConflict();
  var content = "<div class='dividebuy-slip_tooltip_container slip_tooltip_container'><div class='slip_tooltip_content'><span class='tooltip-box'><span class='blue'>DivideBuy - The easy Interest-Free Checkout.</span> Spend £"+minOrderamount+" in total to be eligible to Spread the Cost, Interest-Free using our <span class='blue'>secure platform</span> to fill out our <span class='blue'>60 second application</span>. With us you'll get an <span class='blue'>instant decision. 96% acceptance rate</span> and a <span class='blue'>choice of instalment options</span> to suit you.</span></div></div>";
  if (!(jq1113('body').find('.slip_tooltip_container').length)) {
    jq1113(content).appendTo('body').fadeIn('slow');
  }
  jq1113(document).on({
    mouseenter: function () {
      // Hover code
      var content = "<div class='dividebuy-slip_tooltip_container slip_tooltip_container'><div class='slip_tooltip_content'><span class='tooltip-box'><span class='blue'>DivideBuy - The easy Interest-Free Checkout.</span> Spend £"+minOrderamount+" in total to be eligible to Spread the Cost, Interest-Free using our <span class='blue'>secure platform</span> to fill out our <span class='blue'>60 second application</span>. With us you'll get an <span class='blue'>instant decision. 96% acceptance rate</span> and a <span class='blue'>choice of instalment options</span> to suit you.</span></div></div>";
      if (!(jq1113('body').find('.slip_tooltip_container').length)) {
        jq1113(content).appendTo('body').fadeIn('slow');
      }
    },
    tap: function () {
      // Hover code
      var content = "<div class='dividebuy-slip_tooltip_container slip_tooltip_container'><div class='slip_tooltip_content'><span class='tooltip-box'><span class='blue'>DivideBuy - The easy Interest-Free Checkout.</span> Spend £"+minOrderamount+" in total to be eligible to Spread the Cost, Interest-Free using our <span class='blue'>secure platform</span> to fill out our <span class='blue'>60 second application</span>. With us you'll get an <span class='blue'>instant decision. 96% acceptance rate</span> and a <span class='blue'>choice of instalment options</span> to suit you.</span></div></div>";
      if (!(jq1113('body').find('.slip_tooltip_container').length)) {
        jq1113(content).appendTo('body').fadeIn('slow');
      }
    },
    mouseleave: function () {
      // Hover out code
      jq1113('.slip_tooltip_container').remove();
    }
  }, '.span_imgchange');

  jq1113(document).on('mousemove', ".span_imgchange" , function(e) {
    mousemovebtn(e, this)
  });

  mousemovebtn = function(evt, that) {
    // Mouse out code
    var tooltip_ele = jq1113(".slip_tooltip_container");
    var pageLeft = evt.pageX;
    var pageTop = evt.pageY;
    var windowWidth = jq1113(window).width();
    var windowHeight = jq1113(window).height();
    var tooltipWidth = tooltip_ele.width();
    var tooltipHeight = tooltip_ele.height();
    var scrollTop = jq1113(window).scrollTop();
    var tooltip_offset = tooltip_ele.offset();
    var tooltip_top = tooltip_offset.top;
    var offset = jQuery(that).offset();
    var span_top = jQuery(that).offset().top;
    if ((pageLeft + tooltipWidth + 30) > windowWidth) {
      pageLeft -= tooltipWidth;
      pageLeft -= 30;
    }

    if ((span_top - scrollTop - 20) < tooltipHeight) {
      pageTop += 30;
    } else {
      pageTop -= (tooltipHeight + 30);
    }
    var mousex = pageLeft; //Get X coordinates
    var mousey = pageTop; //Get Y coordinates
    jq1113('.slip_tooltip_container').css({top: mousey, left: mousex});
  }

}
// close popup jquery
function closePopup()
{
  jQuery("html").addClass('loader-on');
  jQuery('html,body').animate({
    scrollTop: jQuery('#test').css('top')
  }, 800, function () {

    jQuery('html, body').animate({
      scrollTop: 0
    }, 800);

  });

  jQuery('#dividebuy_modal').removeClass('in-modal');
  jQuery('body').removeClass('dividebuy-modal');
  setTimeout(function() { jQuery("#dividebuy_modal").css("display","none"); }, 500);        
  jQuery(".loader-set").css('display', 'block');
  setTimeout(function () {
    location.reload();
  }, 5000);
}

// close popup jquery
function closeSoftCreditPopup()
{
    jQuery('#dividebuy_modal_softcredit_search').removeClass('in-modal');
    jQuery('body').removeClass('dividebuy-modal-open');
    jQuery("#frame-dividebuy-softcredit-check").attr("src", "");
    setTimeout(function() { jQuery("#dividebuy_modal_softcredit_search").css("display","none"); }, 500);
    var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
          if(isMobile){
              var gotoHistory = browserHistory - (history.length );
              setTimeout(function(){
                window.history.go(gotoHistory);
                	setTimeout(function(){
                    window.history.back();
                 }, 500);
            }, 1000);
        }
        else{       
          var isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
      if(isIPadPro){        
          var gotoHistory = browserHistory - (history.length + 1); 
          setTimeout(function(){
                history.go(gotoHistory);
             setTimeout(function(){        
                    window.history.back();
                }, 100);
          }, 1000);
      }
      else{
          var gotoHistory = browserHistory - history.length; 
          window.history.go(gotoHistory);
      }
          }
}

//Set cookies
function createCookie(name, value,hour) {
  if (hour) {
    var date = new Date();
    date.setTime(date.getTime() + (hour * 3600 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";               

  document.cookie = name + "=" + value + expires + "; path=/";

  return true;
}

//Erase cookies
function eraseCookie(name) {
  createCookie(name, "", -1);
}

//check cookies 
function check_Cookies(name)
{
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}


//function for shippings
//Added discount option in dividebuy checkout popup
function shipping_popup()
{

  var data_response = '<div class="shipping_information pull-left">';
  data_response += '<div class="row">';
  data_response += '<div class="option-note blue-text text-center">Enter your postcode to view delivery options</div>';
   data_response += '<div class="col-sm-8 col-md-8 col-lg-9">';
  data_response += '<div class="row">';
  data_response += '<div class="col-sm-4 col-md-4 col-lg-3 shipping-margin">';
  data_response += '<label for="user_postcode" class="custom-label pull-left your-postcode">Your postcode:</label>';
  data_response += '</div>'; 
  data_response+=  '<div class="col-sm-8 col-md-8 col-lg-9">';     
  data_response += '<div class="dividebuy-postcode">';        
  data_response += '<input type="text" name="userPostcode" class="required-entry form-control" id="user_postcode"/></div>';        
  data_response += '<div class="validation-advice" id="postcode_error"></div>';        
  data_response += '</div>';   
  data_response += '</div>'; 
   data_response += '</div>'; 
    data_response += '<div class="col-sm-4 col-md-4 col-lg-3">'; 
  data_response += '<span  class="btn-blue ship-estimation" id="get_shipping_estimate" onclick="getForShippingRates()"  title="View options">View options</span>';
  data_response += '</div>';
 

  data_response+='<div  class="clearfix"></div>';
  data_response+='</div>';
  data_response+='<div class="shipping_note blue-text">';
  data_response+='<strong>Please check that the postcode you enter is correct. Shipping is calculated using your postcode and cannot be changed later without cancelling your order and starting again.</strong></div>';
  data_response+='<div class="clearfix"></div>'
  data_response+='</div>';
  data_response+='<div class="clearfix"></div>';
  data_response += '</div>';
 
  return data_response;
}

//function html for checkout as guest
function checkout_guest()
{
  
  var logo_url = jQuery('.retailerLogo').attr('src');

  var logo_exist = 0;
  if(logo_url === undefined || logo_url  === null)
  {
    logo_url = jQuery('#shop_name').val();
  }
  else
  {
    var logo_exist=1;
  }
  var data_response ='';
  data_response += "<div class='row'>";
  data_response += "<div class='col-sm-5 col-md-4 col-xs-12'>";
  data_response += "<div class='logo-img'>";
  data_response += "<a class='dividebutlogo' href='/' itemprop='url'>";
  if(logo_exist == 1)
  {
    data_response += '<img src="'+logo_url+'"/>';
  }
  else
  {
    data_response += logo_url;
  }
  data_response += "</a>";
  data_response += "</div>";
  data_response += "</div>";
  data_response += "</div>";
  data_response += "<div class='clearfix'></div>";
  data_response += "<div class='row'>";
  data_response += "<div class='col-md-6 col-sm-6 checkout-guest'>";
  data_response += "<h4 class='checkout-titile'>Checkout as a cygnet guest</h4>";
  data_response += "<a class='btn-grey' id='btn_continue_guest'onclick='logindata()' >Continue</a>";
  data_response += "</div>";
  data_response += "<div class='col-md-6 col-sm-6 text-center'>";
  data_response += '<img src="https://portalapi.dividebuydemo.co.uk/Shopify-app/assets/dividebuybottom.png"/>';
  data_response += "</div>";
  return data_response;

}
//Popup user login 
function After_existinguser()
{
  jQuery('#dividebuy_modal').css('display', 'block');
  jQuery('#dividebuy_modal').addClass('in-modal');
  jQuery('body').addClass('dividebuy-modal');
  jQuery.ajax({
    type: 'post',
    timeout: 8000,
    success: function(data){
      var product_check = getTotalcheck();
      if(product_check == 0)
      {
        var data = shipping_popup();
      }
      else
      {
        var data = divdebuycart();
      }

      jQuery('#div_login_form').html(data);

      jQuery("#dividebuy-shipping-loader").hide(); 
    },
    error: function () {
      jQuery('#dividebuy_modal').css('display', 'none');
      eraseCookie('dividebuy_guest');
      alert("An error has occurred. Please try again later.");
      window.location.reload();
    }
  });

}

//Popup main check for popups sequences
function Popup_Check()
{
  jQuery('#dividebuy_modal').css('display', 'block');
  jQuery('#dividebuy_modal').addClass('in-modal');
  jQuery('body').addClass('dividebuy-modal');
  jQuery.ajax({
    type: 'post',
    timeout: 8000,
    success: function(data){
      var cookies_status = check_Cookies('dividebuy_guest');
      if(cookies_status != null)
      {
        var product_check = getTotalcheck();
        if(product_check == 1)
        {
          var data = shipping_popup();
        }
        else
        {
          var data = divdebuycart();
        }
      }
      else{
        var data = checkout_guest();
      }

      jQuery("#div_login_form").html(data);

      jQuery("#dividebuy-shipping-loader").hide(); 

    },
    error: function () {
      jQuery('#dividebuy_modal').css('display', 'none');
      eraseCookie('dividebuy_guest');
      alert("An error has occurred. Please try again later.");
      window.location.reload();
    }
  });
}

/* shipping codes */

function checkPostCode (toCheck) {

  // Permitted letters depend upon their position in the postcode.
  var alpha1 = "[abcdefghijklmnoprstuwyz]";                       // Character 1
  var alpha2 = "[abcdefghklmnopqrstuvwxy]";                       // Character 2
  var alpha3 = "[abcdefghjkpmnrstuvwxy]";                         // Character 3
  var alpha4 = "[abehmnprvwxy]";                                  // Character 4
  var alpha5 = "[abdefghjlnpqrstuwxyz]";                          // Character 5
  var BFPOa5 = "[abdefghjlnpqrst]";                               // BFPO alpha5
  var BFPOa6 = "[abdefghjlnpqrstuwzyz]";                          // BFPO alpha6

  // Array holds the regular expressions for the valid postcodes
  var pcexp = new Array ();

  // BFPO postcodes
  pcexp.push (new RegExp ("^(bf1)(\\s*)([0-6]{1}" + BFPOa5 + "{1}" + BFPOa6 + "{1})$","i"));

  // Expression for postcodes: AN NAA, ANN NAA, AAN NAA, and AANN NAA
  pcexp.push (new RegExp ("^(" + alpha1 + "{1}" + alpha2 + "?[0-9]{1,2})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

  // Expression for postcodes: ANA NAA
  pcexp.push (new RegExp ("^(" + alpha1 + "{1}[0-9]{1}" + alpha3 + "{1})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

  // Expression for postcodes: AANA  NAA
  pcexp.push (new RegExp ("^(" + alpha1 + "{1}" + alpha2 + "{1}" + "?[0-9]{1}" + alpha4 +"{1})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

  // Exception for the special postcode GIR 0AA
  pcexp.push (/^(GIR)(\s*)(0AA)$/i);

  // Standard BFPO numbers
  pcexp.push (/^(bfpo)(\s*)([0-9]{1,4})$/i);

  // c/o BFPO numbers
  pcexp.push (/^(bfpo)(\s*)(c\/o\s*[0-9]{1,3})$/i);

  // Overseas Territories
  pcexp.push (/^([A-Z]{4})(\s*)(1ZZ)$/i);  

  // Anguilla
  pcexp.push (/^(ai-2640)$/i);

  // Load up the string to check
  var postCode = toCheck;

  // Assume we're not going to find a valid postcode
  var valid = false;

  // Check the string against the types of post codes
  for ( var i=0; i<pcexp.length; i++) {

    if (pcexp[i].test(postCode)) {

      // The post code is valid - split the post code into component parts
      pcexp[i].exec(postCode);

      // Copy it back into the original string, converting it to uppercase and inserting a space 
      // between the inward and outward codes
      postCode = RegExp.$1.toUpperCase() + " " + RegExp.$3.toUpperCase();

      // If it is a BFPO c/o type postcode, tidy up the "c/o" part
      postCode = postCode.replace (/C\/O\s*/,"c/o ");

      // If it is the Anguilla overseas territory postcode, we need to treat it specially
      if (toCheck.toUpperCase() == 'AI-2640') {postCode = 'AI-2640'};

      // Load new postcode back into the form element
      valid = true;

      // Remember that we have found that the code is valid and break from loop
      break;
    }
  }

  // Return with either the reformatted valid postcode or the original invalid postcode
  if (valid) {return postCode;} else return "";
}


//For auto formating the zipcode on key press

jQuery(document).bind('DOMNodeInserted', function() {
  jQuery("#user_postcode").keyup(function () {
    var newPostCode = checkPostCode(document.getElementById('user_postcode').value);
    if (newPostCode) {
      document.getElementById('user_postcode').value = newPostCode;
    }
  });


});

//looking for scroll class
function updateTable() {
  if(jQuery('body').find('.shopping-scroll').length > 1 || jQuery('body').find('.cs-scroll').length > 0){
    loadScript();
  }else
  {
    setTimeout(updateTable, 1000);
  }
}
updateTable();

//Loading the script
function loadScript()
{
  setTimeout(function() { jQuery(".popup #dividebuy-shipping-loader").hide(); }, 6000);
}
//getting the order amount
function getOrderAmount(serializeData){
  
  var _sarray = [];
  for(value in serializeData ){
       _sarray[value] = serializeData[value].value;
      
    } 
    var minValueInstall = Math.min.apply(Math,_sarray); 
    return minValueInstall;
}

// Code for loading iFrame of soft credit search
function displayCreditPopup(softsearchSplashKey, page){
    jQuery(".popup #shipping-loader-softsearch").show();
    if(page == "checkout") {
    var customerEmail = jQuery('.review-block__inner .review-block__content bdo').html();
    jQuery("#frame-dividebuy-softcredit-check").attr("src", "https://softsearch.dividebuydemo.co.uk?splashKey="+softsearchSplashKey+"&isShopify=1"+"&customerEmail="+customerEmail);
    } else {
    jQuery("#frame-dividebuy-softcredit-check").attr("src", "https://softsearch.dividebuydemo.co.uk?splashKey="+softsearchSplashKey);  
    }
    jQuery('body').addClass('dividebuy-modal-open');
    jQuery('#dividebuy_modal_softcredit_search').css('display', 'block');
    jQuery('#dividebuy_modal_softcredit_search').addClass('in-modal');
    
    var iframe = document.getElementById("frame-dividebuy-softcredit-check");
    if (iframe.attachEvent) {
        iframe.attachEvent("onload", function () {
            jQuery(".popup #shipping-loader-softsearch").hide();
        });
    } else {
        iframe.onload = function () {
            jQuery(".popup #shipping-loader-softsearch").hide();
        };
    }
}

window.addEventListener('message', receiver, false);
function receiver(e) {
    if (e.data == 'soft-search-popup-close') {
        closeSoftCreditPopup();
      }
     if(e.data == "soft-search-popup-back")
        {
            if(jQuery("#frame-dividebuy-softcredit-check").attr("src") != '')
            {
                jQuery('#dividebuy_modal_softcredit_search').removeClass('in-modal');
                jQuery("body").removeClass('dividebuy-modal-open');
                jQuery("#frame-dividebuy-softcredit-check").attr("src", "");
                setTimeout(function() { jQuery("#dividebuy_modal_softcredit_search").css("display","none"); }, 500);
                var gotoHistory = browserHistory - history.length;       
                window.history.go(gotoHistory);
            }        
        }
    if(e.data == 'isShopify') {
        // close popup
        closeSoftCreditPopup();
        // call go to checkout function
        jQuery('#checkout_payment_gateway_33848590447').trigger('click');
        jQuery('.shown-if-js .step__footer__continue-btn').trigger('click');
    }
    if (e.data.isHeight) {
        jQuery('#frame-dividebuy-softcredit-check').height(e.data.isHeight);
    }
}

// Code for close the tooltip, outside the container
jQuery(document).mouseup(function(e){
  var container = jQuery(".dividebuy-tooltip");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.hide();
    }
});

// Code for close the tooltip, on the press of esc.
jQuery( document ).on( 'keydown', function ( e ) {
    var container = jQuery(".dividebuy-tooltip");
    if ( e.keyCode === 27 ) { // ESC
        container.hide();
    }
});

// Dispalying tooltip content based on image height on product page
function tooltipPosition(){
    var tooltipAnchorImage = document.getElementById('dividebuy-softsearch-text');
    var windowInnerHeight = window.innerHeight;
    var tooltipAnchorBottom = tooltipAnchorImage.getBoundingClientRect().bottom;
    var tooltipContentWrapperHeight = 0;
    var tooltipPosition = 'bottom';
    document.querySelector('.dividebuy-tooltip').style.display = 'block';
    tooltipContentWrapperHeight = document.querySelector(".dividebuy-tooltip");
    tooltipContentWrapperHeight = tooltipContentWrapperHeight.clientHeight;
    document.querySelector('.dividebuy-tooltip').style.display = 'none';

    // Getting banner height
    var imageBanner = document.querySelector("#dividebuy_image_after_cart #dividebuy-text");
    var bannerHeight = imageBanner.clientHeight;
    if (tooltipContentWrapperHeight + tooltipAnchorBottom > windowInnerHeight) {
        tooltipPosition = 'top';
    }
    if (tooltipPosition == 'bottom') {
        // Getting DivideBuy text and softsearch text offset
        var dividebuy_image_offset = jQuery('#dividebuy_image_after_cart').offset().top;
        var dividebuy_softsearch_offset = jQuery('#dividebuy-softsearch-text').offset().top;
        jQuery('.dividebuy-tooltip').css({
            'top': jQuery('#dividebuy-softsearch-text').innerHeight() + (dividebuy_softsearch_offset - dividebuy_image_offset) + 4,
            'bottom' : 'auto'
        });
    } else {
        jQuery('.dividebuy-tooltip').css({
            'bottom': bannerHeight + 6,
            'top' : 'auto'
        });
    }
    jQuery(".tooltip-db").fadeIn('fast');
}